import { ClientAnalytics } from './clientAnalytics'

type SectionEvent =
  | 'faq:section:expand_all'
  | 'faq:section:collapse_all'

type ItemEvent =
  | 'faq:item:open'
  | 'faq:item:close'

type LinkEvent =
  | 'faq:next_step:click'
  | 'faq:waitlist:click'
  | 'faq:contact:email_click'
  | 'faq:privacy_policy:click'
  | 'faq:bug_report:click'

export type FaqAnalyticsEvent = SectionEvent | ItemEvent | LinkEvent

export function trackFaq(event: FaqAnalyticsEvent, properties?: Record<string, unknown>) {
  ClientAnalytics.track(event, properties)
}
